/**
 * Shown when a user's account has no accessible sections at all
 * (no nav item permission matches the token).
 */
export function NoAccessNotice() {
  return (
    <div className="flex items-center justify-center h-full p-6">
      <div className="text-center max-w-md">
        <div className="text-4xl mb-4">🔒</div>
        <h2 className="text-lg font-semibold mb-2">Zugriff verweigert</h2>
        <p className="text-sm text-muted-foreground">
          Ihrem Konto sind keine Bereiche zugewiesen. Kontaktieren Sie Ihren Administrator, um Zugriff zu erhalten.
        </p>
      </div>
    </div>
  )
}
